import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getPortGroupList(params) {
  return request({
    url: URL.mdm.basicData.portGroup,
    method: 'get',
    params
  })
}

export function savePortGroup(data) {
  return request({
    url: URL.mdm.basicData.portGroup,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delPortGroup(uuid) {
  return request({
    url: URL.mdm.basicData.portGroup + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
